import React, { Component } from "react";
import MaskedInput from "react-text-mask";

export default class DataInputsLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChangedHandler: props.isChangedHandler,
      onBlurHandler: props.onBlurHandler,
      onFocusHandler: props.onFocusHandler,
    };
  }

  createInputField(field) {
    const { propsClassName, mask } = this.props;
    const { onBlurHandler, isChangedHandler } = this.state;

    const className1 = field.error ? " blue-border body10" : " body10";
    const className = field.active ? "blue-animation " : "";

    if (field.readonly) {
      return (
        <input
          key={`input-${field.propName}`}
          name={field.name}
          ref={field.propName}
          value={field.value}
          className={`${propsClassName} body10`}
          onBlur={onBlurHandler}
          onChange={isChangedHandler}
          data-fieldname={field.propName}
          data-cy={field.propName}
          disabled
        />
      );
    } else if (mask !== "" && mask !== null && mask !== undefined) {
      if (
        field.name === "STATE" ||
        field.name === "CITY" ||
        field.name === "SUITE" ||
        field.name === "STREET"
      ) {
        return (
          <input
            name={field.name}
            ref={field.propName}
            value={field.value}
            className={`${propsClassName} ${className} ${className1} `}
            data-fieldname={field.propName}
            data-cy={field.propName}
            onBlur={onBlurHandler}
            onChange={isChangedHandler}
          />
        );
      } else {
        return this.getMaskedInput(field, mask, propsClassName);
      }
    } else {
      return this.getZipCodeInput(field);
    }
  }

  getZipCodeInput(field) {
    const { onBlurHandler, isChangedHandler } = this.state;
    const { propsClassName, maxLength } = this.props;
    const className1 = field.error ? " blue-border body10" : " body10";
    const className = field.active ? "blue-animation " : "";
    return (
      <input
        name={field.name}
        ref={field.propName}
        value={field.value}
        className={`${propsClassName} ${className} ${className1} `}
        data-fieldname={field.propName}
        data-cy={field.propName}
        onBlur={onBlurHandler}
        onChange={isChangedHandler}
        maxlength={maxLength && field.name === "ZIP CODE" ? maxLength : ""}
      />
    );
  }

  getMaskedInput(field, mask, propsClassName) {
    const { onBlurHandler, isChangedHandler, onFocusHandler } = this.state;
    const className1 = field.error ? " blue-border body10" : " body10";
    const className = field.active ? "blue-animation " : "";
    return (
      <MaskedInput
        key={`input-${field.propName}`}
        name={field.name}
        mask={mask}
        ref={field.propName}
        onChange={isChangedHandler}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
        data-fieldname={field.propName}
        data-cy={field.propName}
        className={`${propsClassName} ${className} ${className1} `}
        value={field.value}
        showMask
      />
    );
  }

  createCheckboxField(field) {
    const className1 = field.error ? " blue-border" : " ";
    const className = field.active ? "blue-animation" : "checkbox-element";
    return (
      <input
        key={`chexkbox-${field.propName}`}
        name={field.name}
        data-fieldname={field.propName}
        data-cy={field.propName}
        type="checkbox"
        className={`${propsClassName} ${className} ${className1} `}
        onBlur={onBlurHandler}
        ref={field.propName}
        checked={field.value}
        onChange={isChangedHandler}
      />
    );
  }

  createDropdownField(field) {
    const { className: contentClass = "" } = this.props;
    const { options } = field;
    const className = field.error ? "blue-border" : " ";

    return (
      <select
        name={field.name}
        onChange={isChangedHandler}
        className={`${propsClassName} ${className}  `}
        onBlur={onBlurHandler}
        value={field.value}
        data-fieldname={field.propName}
      >
        <option key={`dd-${"none"}`}> - </option>
        {options.map((option) => (
          <option
            key={`dd-${option.value}`}
            value={option.value}
            className={contentClass}
            data-cy={option.value}
          >
            {option.displayValue || option.value}
          </option>
        ))}
      </select>
    );
  }

  createRadioButton(field) {
    const { options } = field;
    const { name } = field;

    const className1 = field.error ? " blue-border" : " ";
    const className = field.active ? "blue-animation" : "";

    return options.map((option) => {
      return (
        <div
          key={`radio-${option.value}`}
          onChange={isChangedHandler}
          className={`${propsClassName} ${className} ${className1} radio-button-element`}
          onBlur={onBlurHandler}
        >
          <input
            type="radio"
            name={name}
            data-cy={field.propName}
            data-fieldname={field.propName}
            value={option.value}
          />
          <span>{option.value}</span>
        </div>
      );
    });
  }

  createSingleField(field) {
    const { labelClass = "", showDivider } = this.props;
    if (field.hidden) return;

    const fieldType = field.type || "input";
    let inputField = null;

    if (field.type && field.type === "dropdown") {
      inputField = this.createDropdownField(field);
    } else if (field.type && field.type === "radio") {
      inputField = this.createRadioButton(field);
    } else if (field.type && field.type === "checkbox") {
      inputField = this.createCheckboxField(field);
    } else {
      inputField = this.createInputField(field, fieldType);
    }

    return (
      <div key={`single-${field.name}`} className={`field ${fieldType}`}>
        <label className={`${labelClass} labels21`} htmlFor={field.propName}>
          {field.name}
        </label>
        {inputField}
        {showDivider && <span className="divider"></span>}
      </div>
    );
  }

  createDoubleField(fields) {
    const { labelClass = "" } = this.props;
    const [field1, field2] = fields;
    const fieldType1 = field1.type || "input";
    const fieldType2 = field2.type || "input";

    const inputField1 = this.createInputField(field1, fieldType1);
    const inputField2 = this.createInputField(field2, fieldType2);

    return (
      <div key={`${field1.name}-${field2.name}`} className="double-field">
        <div className="field1">
          <label className={`${labelClass} labels21`} htmlFor={field1.propName}>
            {field1.name}
          </label>
          {inputField1}
        </div>
        <div className="field2">
          <label className={`${labelClass} labels21`} htmlFor={field2.propName}>
            {field2.name}
          </label>
          {inputField2}
        </div>
      </div>
    );
  }

  createDataTable(data) {
    return data.map((row) => {
      if (row.double) {
        return this.createDoubleField(row.fields);
      } else {
        return this.createSingleField(row);
      }
    });
  }

  render() {
    const { data } = this.props;
    return this.createDataTable(data);
  }
}
